import { Hero } from "@/components/marketing/hero"
import { ServicesStrip } from "@/components/marketing/services-strip"
import { Work } from "@/components/marketing/work"
import { Products } from "@/components/marketing/products"
import { Philosophy } from "@/components/marketing/philosophy"
import { Principles } from "@/components/marketing/principles"
import { ClientsStrip } from "@/components/marketing/clients-strip"
import { CtaBand } from "@/components/marketing/cta-band"

export function Home() {
  return (
    <main>
      <div className="flex min-h-screen flex-col">
        <Hero />
        <ServicesStrip />
      </div>
      <Work />
      <Products />
      <Philosophy />
      <Principles />
      <ClientsStrip />
      <CtaBand />
    </main>
  )
}
